var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.notice)?_c('van-notice-bar',{staticClass:"noticeWrap",attrs:{"scrollable":"","left-icon":"volume-o","text":_vm.notice}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }